export const AGREEMENT_COOKIE_NAME = "ng_agreement_accepted";
export const AGREEMENT_COOKIE_EXPIRE = 10;

export enum EAgreementEvents {
  ACCEPTED = "agreementAccepted",
}
